import React from 'react'

const pokemonsContext = React.createContext();

export { pokemonsContext }